import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import CodeRoundedIcon from '@mui/icons-material/CodeRounded';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import DesktopWindowsRoundedIcon from '@mui/icons-material/DesktopWindowsRounded';
import CloudRoundedIcon from '@mui/icons-material/CloudRounded';
import HubRoundedIcon from '@mui/icons-material/HubRounded';
import SectionHeading from './components/SectionHeading';
import SpotlightCard from './components/SpotlightCard';
import { Stagger } from './components/motion/Reveal';

const pillars = [
  {
    icon: <CodeRoundedIcon />,
    title: 'Full-Stack Development',
    body: 'Robust, scalable web applications using the latest frontend and backend technologies.',
    accent: '210, 98%, 55%',
  },
  {
    icon: <PhoneIphoneRoundedIcon />,
    title: 'Mobile Development',
    body: 'iOS and Android expertise for seamless, high-performance mobile experiences.',
    accent: '265, 90%, 62%',
  },
  {
    icon: <DesktopWindowsRoundedIcon />,
    title: 'Windows Desktop Apps',
    body: 'Powerful, user-friendly Windows applications tailored to your business needs.',
    accent: '190, 95%, 50%',
  },
  {
    icon: <CloudRoundedIcon />,
    title: 'Cloud Applications',
    body: 'Scalable, secure, and efficient cloud-based solutions for businesses of all sizes.',
    accent: '150, 70%, 45%',
  },
  {
    icon: <HubRoundedIcon />,
    title: 'Distributed Systems',
    body: 'High-performance distributed systems that enhance reliability and scalability.',
    accent: '25, 95%, 55%',
  },
];

export default function AboutUs() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 14, sm: 20 } }}>
      <SectionHeading
        eyebrow="About us"
        title="Software, crafted with"
        highlight="excellence"
        subtitle="At FalconXcellence, we deliver high-quality software across full-stack web development, mobile applications, Windows desktop applications, cloud computing, and distributed systems — turning ambitious ideas into dependable products."
        maxWidth={780}
      />

      <Stagger style={{ marginTop: 48 }}>
        <Grid container spacing={2.5}>
          {pillars.map((p) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={p.title}>
              <SpotlightCard>
                <Box sx={{ p: 3.5, height: '100%' }}>
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: 2,
                      display: 'grid',
                      placeItems: 'center',
                      mb: 2,
                      color: `hsl(${p.accent})`,
                      background: `linear-gradient(135deg, hsla(${p.accent},0.18), hsla(${p.accent},0.04))`,
                      border: '1px solid',
                      borderColor: `hsla(${p.accent},0.3)`,
                      '& svg': { fontSize: 26 },
                    }}
                  >
                    {p.icon}
                  </Box>
                  <Typography sx={{ fontWeight: 700, fontSize: '1.1rem', mb: 1 }}>
                    {p.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.65 }}>
                    {p.body}
                  </Typography>
                </Box>
              </SpotlightCard>
            </Grid>
          ))}
        </Grid>
      </Stagger>
    </Container>
  );
}
